export const PreflightStatus = {
    NOT_SENT: "NOT_SENT",
    PROCESSING: "PROCESSING",
    COMPLETED: "COMPLETED",
    MODIFIED: "MODIFIED",
    ERROR: "ERROR",
} as const;

export type PreflightStatusValue = (typeof PreflightStatus)[keyof typeof PreflightStatus];

export const CreativeXScore = {
    MIN: 0,
    MAX: 1,
    THRESHOLD: 0.8,
} as const;
